var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMobile30(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M21 7c0-1-1-2-1.933-2h-8.134C10 5 9 6 9 7v16c0 1 1 2 1.933 2h8.134C20 25 21 24 21 23V7zm-9 0h6a1 1 0 0 1 1 1v13h-8V8a1 1 0 0 1 1-1zm3 15c.571 0 1 .375 1 1 0 .5-.429 1-1 1-.558 0-1-.5-1-1s.429-1 1-1z",
    clipRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTIxIDdjMC0xLTEtMi0xLjkzMy0yaC04LjEzNEMxMCA1IDkgNiA5IDd2MTZjMCAxIDEgMiAxLjkzMyAyaDguMTM0QzIwIDI1IDIxIDI0IDIxIDIzVjd6bS05IDBoNmExIDEgMCAwIDEgMSAxdjEzaC04VjhhMSAxIDAgMCAxIDEtMXptMyAxNWMuNTcxIDAgMSAuMzc1IDEgMSAwIC41LS40MjkgMS0xIDEtLjU1OCAwLTEtLjUtMS0xcy40MjktMSAxLTF6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=";
export { SvgMobile30 as ReactComponent };